/* React hooks */
import {useState} from "react";
/* Components */
import FormFunerariumSchedule from "../../../forms/funerarium/FormFunerariumSchedule";
import useData from "../../../hooks/useData";
import Icon from "../../../components/common/Icon";


export default function ViewFunerariumSchedule({ apiFunerariumGeneralInfos, legend }) {
    const { funerariumInfos } = useData();
    const [ showModal, setShowModal ] = useState(false);

    const handleFormFunerariumSchedule = () => {
        setShowModal(true);
    }


    return (
        <>
            { showModal &&
                <div className="modal funerarium-schedule">
                    <FormFunerariumSchedule apiFunerariumGeneralInfos={apiFunerariumGeneralInfos} setShowModal={setShowModal} legend="Modification des horaires"/>
                </div>
            }
            <fieldset>

                <Icon span="Horaires d'ouverture" source="fa-solid fa-clock"/>
                <div className="funerarium-hours">
                    <div className="hours-column">
                        <span className="hours-title">Le matin</span>
                        <div className="form-input">
                            <label htmlFor="morningStart">De :</label>
                            <span>{funerariumInfos?.morningStart ? funerariumInfos?.morningStart : "" }</span>
                        </div>
                        <div className="form-input">
                            <label htmlFor="morningEnd">A :</label>
                            <span>{funerariumInfos?.morningEnd ? funerariumInfos?.morningEnd : ""}</span>
                        </div>
                    </div>
                    <div className="hours-column">
                        <span className="hours-title">L'après-midi</span>
                        <div className="form-input">
                            <label htmlFor="afternoonStart">De :</label>
                            <span>{funerariumInfos?.afternoonStart ? funerariumInfos?.afternoonStart : ""}</span>
                        </div>
                        <div className="form-input">
                            <label htmlFor="afternoonEnd">A :</label>
                            <span>{funerariumInfos?.afternoonEnd ? funerariumInfos?.afternoonEnd : ""}</span>
                        </div>
                    </div>
                    <div className="hours-column visit-infos-column">
                        <div className="form-input">
                            <label htmlFor="visitInfos">Informations de visite</label>
                            <textarea disabled="disabled" value={funerariumInfos?.visitInfos || ""}></textarea>
                        </div>
                    </div>
                </div>
                <div className="buttons-container">
                <button type="button" className="red-button" onClick={handleFormFunerariumSchedule}>
                    <i className="fa fa-pen"/><span>Modifier les informations</span>
                </button>
            </div>
            </fieldset>
        </>

    )
}